export enum AssignedTeamRoles {
  viewer = 'Viewer',
  responder = 'Responder',
  reviewer = 'Reviewer'
}